import HundredBricksAPIError from '../../HundredBricksAPIError';
class RevolvingFundsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RevolvingFundsError', ...args);
    }
}
export default RevolvingFundsError;
